import { DeviceIcon } from "../assets/digital_twin_icons/digitalTwinIcons";
const Device = ({
  top,
  left,
  right,
  bottom,
  srcOn,
  srcOff,
  srcLow,
  lineSrc,
  lineTop,
  lineLeft,
  lineRight,
  lineBottom,
  lineRotate,
  lineHeight,
  signalStrength = 0,
  active = false,
  energy = 0,
  position = "top",
  threshold = 50,
}) => {
  const lowSignal = signalStrength < threshold;

  const deviceStyle = {
    top: top ? `${top}` : undefined,
    left: left ? `${left}` : undefined,
    right: right ? `${right}` : undefined,
    bottom: bottom ? `${bottom}` : undefined,
  };

  const lineStyle = {
    top: lineTop ? `${lineTop}` : undefined,
    left: lineLeft ? `${lineLeft}` : undefined,
    right: lineRight ? `${lineRight}` : undefined,
    bottom: lineBottom ? `${lineBottom}` : undefined,
    transform: lineRotate ? `rotate(${lineRotate})` : undefined,
    height: lineHeight ? `${lineHeight}` : undefined,
  };

  const backgroundColor = active
    ? lowSignal
      ? "bg-[#FFE5B5]"
      : "bg-[#ACD6FF]"
    : "bg-[#D9D9D9]";
  return (
    <div>
      <div className="group relative">
        <div
          className={`w-auto absolute z-10 rounded-md shadow-md p-4 ${backgroundColor}`}
          style={deviceStyle}
        >
          <img
            // className="w-auto absolute z-10"
            // style={deviceStyle}
            src={active ? (lowSignal ? srcLow : srcOn) : srcOff}
            alt="device"
          />
        </div>
        {active && (
          <HoverBox
            signalStrength={signalStrength}
            energy={energy}
            location={{ top, bottom, left, right }}
          />
        )}
      </div>
      <img
        className="w-auto absolute"
        style={lineStyle}
        src={lineSrc}
        alt="line"
      />
    </div>
  );
};

export default Device;

const HoverBox = ({
  position = "bottom",
  location,
  signalStrength = 0,
  energy = 0,
}) => {
  const { top, bottom, left, right } = location;

  // Parse numeric values from strings with 'px' units
  // const topValue = parseInt(top, 10);
  // const bottomValue = parseInt(bottom, 10);
  // const leftValue = parseInt(left, 10);
  // const rightValue = parseInt(right, 10);
  const topValue = parseInt(top, 10);
  const bottomValue = parseInt(bottom, 10);
  const leftValue = parseInt(left, 10);
  const rightValue = parseInt(right, 10);

  console.log(topValue, bottomValue, leftValue, rightValue);

  const hoverBoxStyle = {
    top: topValue + 60,
    left: leftValue,
    right: rightValue,
    bottom: bottomValue + 70,
  };

  return (
    <div
      className={`hidden group-hover:block absolute bg-white border border-gray-300 p-4 z-20 rounded shadow-lg`}
      style={hoverBoxStyle}
    >
      <p>
        <strong>Signal Strength:</strong>{" "}
        {Math.round(100 * signalStrength) / 100} dBm
      </p>
      <p className="mb-2">
        <strong>Energy:</strong> {Math.round(100 * energy) / 100} dBm
      </p>
    </div>
  );
};
